import isEqual from 'lodash/isEqual';
// Actions
import {
    EDIT_CLASS_NAME,
    GET_TEACHER_CLASS,
    GET_UPDATED_TEACHER_CLASS,
    CHANGE_PASSWORD
} from './console-actions';
import {
    GET_DEFAULT_COURSE,
    GET_COURSE_COUNTRIES,
    GET_COURSE_YEARS,
    GET_COURSE,
    SET_COURSE_COUNTRIES,
    SET_COURSE_YEAR,
    SET_COURSE,
    RESET_COURSE_YEARS,
    INITIALISE_COURSE_SELECT_OPTIONS,
    GET_NEW_COURSE_AVAILABILITY_CRITERIA,
    GET_UPF_COURSE,
    SET_UPF_COURSE,
    GET_NEW_COURSE,
    SET_NEW_COURSE,
    FETCHING_COURSE_CONTENT
} from './actions/courses-actions';
import {
    EDIT_GROUP_INFORMATION_START,
    EDIT_GROUP_INFORMATION_END,
    UPDATE_GROUP_SELECTION,
    RESET_EDIT_INFORMATION,
    DEFAULT_NEW_COURSE_ID,
    UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT,
    CREATE_MULTI_YEAR_GROUPS,
    NO_UPF_COURSE_FOUND_ID,
    RESET_MULTI_YEAR_GROUPS_FETCH
} from './actions/group-actions';
import {
    SELECT_ALL_CHECKBOX_STUDENT,
    SELECT_CHECKBOX_STUDENT
} from './actions/student-selection-actions';

// Helpers
import { ALL_GROUP_ID } from '../../helpers/enums';
import { getParam } from '../../helpers/utils';

// Initial State
const initialState = {
    isSisSchool: null,
    classGroups: [],
    classGroupStudents: [],
    classes: [],
    currentClassName: '',
    currentClassId: 0,
    groupCountryCode: '',
    // Student Selection values
    mainCheckAllIsSelected: false,
    mainSelectedStudentIds: [],
    /*
        allCurrentStudentIds will determine the selectAll checkbox,
        if there are filters then it's only applicable for the view the user is currently in
    */
    mainAllCurrentStudentIds: [],
    // Course Specific values
    countrySelectValue: '',
    countrySelectOptions: [],
    yearSelectValue: '',
    yearSelectOptions: [],
    courseSelectValue: '',
    courseSelectOptions: [],
    upfCourseSelectOptions: [],
    upfCurrentCourseSuffix: '',
    newCourseSelectOptions: [],
    defaultCountryOption: {},
    defaultYearOption: {},
    defaultAllYearsOption: {},
    defaultCourseOption: {},
    defaultNewCourseOption: {},
    defaultNoNewCourseFoundOption: {},
    upfCourseAdminSelectionOption: {},
    noUPFCourseFoundOption: {},
    groupUpfCourseOption: null,
    groupCourseOption: null,
    groupNewCourseOption: null,
    defaultSelectOptions: {},
    // Other
    hasContentLoaded: false,
    productId: null,
    isFetchingEditInformation: false,
    newCoursesAvailabilityCriteria: {},
    isMultiLevelGroupsCreated: false,
    createdMultiLevelGroupsCount: 0
};

// By default, all groups should be selected + add in allGroups when there's only 1 group
function setGroupVisibleProperty(groups) {
    let existingGroups = groups;
    if (groups.length === 1) {
        existingGroups = [
            {
                groupId: ALL_GROUP_ID,
                name: 'All groups', // This is translated within the component itself
                isDefault: false
            },
            ...existingGroups
        ];
    }
    return existingGroups.map(group => ({
        ...group,
        isSelected: true
    }));
}

function getUpfCourseSelectOptions(state, groupUpfCourse, upfCourseList) {
    const {
        upfCourseAdminSelectionOption,
        noUPFCourseFoundOption,
        upfCurrentCourseSuffix
    } = state;
    const noUPFCourseFound = [noUPFCourseFoundOption];
    const updatedUpfCourseList = [...upfCourseList];
    const upfCourseSelectDefaultOptions = [
        upfCourseAdminSelectionOption
    ];

    if (groupUpfCourse) {
        upfCourseSelectDefaultOptions.push({
            id: groupUpfCourse.id,
            name: `${groupUpfCourse.name} (${upfCurrentCourseSuffix})`
        });

        const existingUpfCourseIndex = updatedUpfCourseList.findIndex(
            course => course.id === groupUpfCourse.id
        );

        if (existingUpfCourseIndex !== -1) {
            updatedUpfCourseList.splice(existingUpfCourseIndex, 1);
        }
    }

    if (upfCourseList.length === 0) {
        return [
            ...noUPFCourseFound,
            ...updatedUpfCourseList
        ];
    }

    return [
        ...upfCourseSelectDefaultOptions,
        ...updatedUpfCourseList
    ];
}

function getCourseSelectOptions(state, groupCourse, courseList) {
    const { defaultCourseOption, upfCurrentCourseSuffix } = state;
    const updatedCourseList = [...courseList];
    const courseSelectDefaultOptions = [defaultCourseOption];

    if (groupCourse) {
        courseSelectDefaultOptions.push({
            id: groupCourse.id,
            name: `${groupCourse.name} (${upfCurrentCourseSuffix})`
        });

        const existingCourseIndex = updatedCourseList.findIndex(course => course.id === groupCourse.id);

        if (existingCourseIndex !== -1) {
            updatedCourseList.splice(existingCourseIndex, 1);
        }
    }

    return [...courseSelectDefaultOptions, ...updatedCourseList];
}

function getNewCourseCurrentSelectValue(state, conquestCourses) {
    const groupNewCourseOption = state.groupNewCourseOption;

    const course = conquestCourses.find(c => c && (
        (groupNewCourseOption && groupNewCourseOption.id === c.id) ||
            (!groupNewCourseOption && c.isDefault === true)
    ));

    return course && course.id ? course.id : DEFAULT_NEW_COURSE_ID;
}

function getNewCourseSelectOptions(state, groupNewCourse, newCourseList) {
    const {
        defaultNoNewCourseFoundOption,
        upfCurrentCourseSuffix,
        defaultNewCourseOption
    } = state;

    // TODO Review the format of newCourseList and simplify the following to 'newCourseList || []' if always an array
    const updatedNewCourseList = Array.isArray(newCourseList) ? [...newCourseList] : [];

    const newCourseSelectDefaultOptions = updatedNewCourseList.length > 0
        ? [defaultNewCourseOption]
        : [defaultNoNewCourseFoundOption];

    // If we have a selected conquest course we push it to the top
    if (groupNewCourse) {
        newCourseSelectDefaultOptions.push({
            id: groupNewCourse.id,
            name: `${groupNewCourse.name} (${upfCurrentCourseSuffix})`
        });

        const existingNewCourseIndex = updatedNewCourseList.findIndex(
            course => course.id === groupNewCourse.id
        );

        if (existingNewCourseIndex !== -1) {
            updatedNewCourseList.splice(existingNewCourseIndex, 1);
        }
    }

    const defaultIndex = updatedNewCourseList.findIndex(c => c.isDefault === true);

    // If we have a default course we push it to the top or underneath the assigned course
    if (defaultIndex !== -1) {
        const defaultCourse = updatedNewCourseList.splice(defaultIndex, 1)[0];
        let assignedIndex = -1;

        if (groupNewCourse) {
            assignedIndex = updatedNewCourseList.findIndex(c => c.id === groupNewCourse.id);
        }

        if (assignedIndex !== -1) {
            updatedNewCourseList.splice(assignedIndex + 1, 0, defaultCourse);
        } else {
            updatedNewCourseList.unshift(defaultCourse);
        }
    }

    return [
        ...newCourseSelectDefaultOptions,
        ...updatedNewCourseList
    ];
}

function isGroupVisible(groupId, groups) {
    const currentGroup = groups.filter(group => group.groupId === groupId);
    return currentGroup && currentGroup[0].isSelected;
}

function setUpAllCurrentStudents(students) {
    return students.map(groupStudent => (
        groupStudent.userProfileId
    ));
}

function setUpStudentVisibility(students) {
    return students.map(student => ({
        ...student,
        isVisible: true
    }));
}

function shouldAllGroupsUpdate(groups, updatedGroup) {
    const validGroupLength = groups.length - 1; // - 1 due to the all groups
    const isSelectedValues = updatedGroup.filter(group => group.isSelected).length;
    return isSelectedValues === validGroupLength;
}

function updateGroupVisibleProperties(groups, value, isSelected) {
    const parsedValue = parseInt(value, 10);
    const updatedGroup = groups.map((group) => {
        // For AllGroups, set the value to whatever the value of isSelected is
        if (parsedValue === ALL_GROUP_ID) {
            return {
                ...group,
                isSelected
            };
        }
        // As the selected value is not allGroups, set allGroups isSelected to be false
        if (group.groupId === ALL_GROUP_ID) {
            return {
                ...group,
                isSelected: false
            };
        }
        // Set the selected group, to be the inverse of what it was
        if (parsedValue === group.groupId) {
            return {
                ...group,
                isSelected: !group.isSelected
            };
        }
        return group;
    });

    // The logic below will determine whether allGroups will be selected when a group was not selected initially
    const selectAllGroups = shouldAllGroupsUpdate(groups, updatedGroup);
    if (selectAllGroups) {
        updatedGroup[0] = {
            ...updatedGroup[0],
            isSelected: true
        };
    }

    return updatedGroup;
}

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case FETCHING_COURSE_CONTENT: {
            return {
                ...state,
                hasContentLoaded: true
            };
        }
        case GET_TEACHER_CLASS: {
            const {
                classGroups,
                classGroupStudents,
                classes,
                externalClassroomId
            } = payload.data;
            const productId = payload.productId;
            const classIdParam = getParam('classId');
            const classId = classIdParam ? Number(classIdParam) : payload.data.classId;

            const currentClassName = classes.filter(item => item.classId === classId);
            const mainAllCurrentStudentIds = setUpAllCurrentStudents(classGroupStudents);
            const initialClassGroupStudents = setUpStudentVisibility(classGroupStudents);

            const resetCheckboxProperties = {
                mainCheckAllIsSelected: false,
                mainSelectedStudentIds: [],
                mainAllCurrentStudentIds
            };

            return {
                ...state,
                productId,
                classGroups: setGroupVisibleProperty(classGroups),
                classGroupStudents: initialClassGroupStudents,
                classes,
                hasContentLoaded: true,
                currentClassName: currentClassName && currentClassName.length > 0 ? currentClassName[0].name : '',
                currentClassId: classId,
                externalClassroomId,
                ...resetCheckboxProperties
            };
        }
        case GET_UPDATED_TEACHER_CLASS: {
            const {
                classGroups,
                classGroupStudents,
                classId,
                externalClassroomId,
                isSisSchool
            } = payload.data;

            const currentClassName = state.classes.filter(item => item.classId === classId);
            const mainAllCurrentStudentIds = setUpAllCurrentStudents(classGroupStudents);
            const initialClassGroupStudents = setUpStudentVisibility(classGroupStudents);

            const resetCheckboxProperties = {
                mainCheckAllIsSelected: false,
                mainSelectedStudentIds: [],
                mainAllCurrentStudentIds
            };

            return {
                ...state,
                classGroups: setGroupVisibleProperty(classGroups),
                classGroupStudents: initialClassGroupStudents,
                hasContentLoaded: true,
                currentClassName: currentClassName && currentClassName.length > 0 ? currentClassName[0].name : '',
                currentClassId: classId,
                externalClassroomId,
                isSisSchool,
                // reset course information as well
                countrySelectValue: '',
                yearSelectValue: '',
                courseSelectValue: '',
                ...resetCheckboxProperties
            };
        }
        case EDIT_CLASS_NAME: {
            const tempClasses = [...state.classes];

            const className = payload.name;
            const classes = tempClasses.map((localClass) => {
                if (localClass.classId === state.currentClassId) {
                    return {
                        ...localClass,
                        name: className
                    };
                }
                return localClass;
            });

            return {
                ...state,
                currentClassName: className,
                classes
            };
        }
        // ------- Course Actions ------- Start
        case GET_DEFAULT_COURSE: {
            return {
                ...state,
                countrySelectValue: '',
                countrySelectOptions: [
                    state.defaultCountryOption,
                    // Set the country dropdown option with country year list
                    ...payload.countryList
                ],
                yearSelectValue: '',
                yearSelectOptions: [
                    state.defaultYearOption,
                    state.defaultAllYearsOption,
                    // Set the year dropdown option with default year list
                    ...payload.yearList
                ],
                courseSelectValue: '',
                courseSelectOptions: getCourseSelectOptions(state, payload.groupCourse, payload.courseList),
                newCourseSelectValue: payload.newCourse,
                newCourseSelectOptions: getNewCourseSelectOptions(
                    state,
                    payload.groupNewCourse,
                    payload.newCourseList
                ),

                upfCourseSelectValue: '-1',
                upfCourseSelectOptions: getUpfCourseSelectOptions(
                    state,
                    payload.groupUpfCourse,
                    payload.upfCourseList
                ),
                groupCountryCode: payload.countryCode
            };
        }
        case GET_COURSE_COUNTRIES: {
            return {
                ...state,
                countrySelectValue: '',
                countrySelectOptions: [
                    state.defaultCountryOption,
                    ...payload.data
                ],
                // reset the year dropdown option
                yearSelectValue: '',
                yearSelectOptions: [
                    state.defaultYearOption
                ],
                // reset the courses dropdown option
                courseSelectValue: '',
                courseSelectOptions: [
                    state.defaultCourseOption
                ]
            };
        }
        case SET_COURSE_COUNTRIES: {
            return {
                ...state,
                countrySelectValue: payload.data,
                // reset the year dropdown option
                yearSelectValue: '',
                yearSelectOptions: [
                    state.defaultYearOption
                ],
                // reset the courses dropdown option
                courseSelectOptions: [
                    state.defaultCourseOption
                ],
                isFetchingEditInformation: false
            };
        }
        case GET_COURSE_YEARS: {
            return {
                ...state,
                yearSelectValue: '',
                yearSelectOptions: [
                    state.defaultYearOption,
                    state.defaultAllYearsOption,
                    ...payload.data
                ],
                // reset the courses dropdown option
                courseSelectOptions: [
                    state.defaultCourseOption
                ]
            };
        }
        case SET_COURSE_YEAR: {
            return {
                ...state,
                yearSelectValue: payload.data,
                // reset the courses dropdown option
                courseSelectOptions: [
                    state.defaultCourseOption
                ],
                isFetchingEditInformation: false
            };
        }
        // This action is called when school courses is being selected
        case RESET_COURSE_YEARS: {
            return {
                ...state,
                yearSelectValue: '',
                yearSelectOptions: [
                    state.defaultYearOption
                ],
                // reset the courses dropdown option as well
                courseSelectValue: '',
                courseSelectOptions: [
                    state.defaultCourseOption
                ],
                isFetchingEditInformation: false
            };
        }
        case GET_COURSE: {
            if (payload.notFound === true) {
                return {
                    ...state,
                    courseSelectOptions: [
                        payload.data
                    ]
                };
            }
            return {
                ...state,
                courseSelectOptions: getCourseSelectOptions(state, state.groupCourseOption, payload.data.courses)
            };
        }
        case SET_COURSE: {
            return {
                ...state,
                courseSelectValue: payload.data,
                isFetchingEditInformation: false
            };
        }
        case GET_UPF_COURSE: {
            if (payload.notFound === true) {
                return {
                    ...state,
                    upfCourseSelectOptions: [
                        payload.data
                    ]
                };
            }

            return {
                ...state,
                upfCourseSelectValue: state.groupUpfCourseOption
                    ? state.upfCourseSelectValue
                    : '-1',
                upfCourseSelectOptions: getUpfCourseSelectOptions(
                    state,
                    state.groupUpfCourseOption,
                    payload.data.upfCourses
                )
            };
        }
        case SET_UPF_COURSE: {
            return {
                ...state,
                upfCourseSelectValue: payload.data,
                isFetchingEditInformation: false
            };
        }
        case GET_NEW_COURSE: {
            if (payload.notFound) {
                return {
                    ...state,
                    newCourseSelectOptions: [
                        payload.data
                    ]
                };
            }
            const { data: { conquestCourses } } = payload;
            const { groupNewCourseOption } = state;
            return {
                ...state,
                newCourseSelectValue: getNewCourseCurrentSelectValue(state, conquestCourses),
                newCourseSelectOptions: getNewCourseSelectOptions(
                    state,
                    groupNewCourseOption,
                    conquestCourses
                )
            };
        }
        case SET_NEW_COURSE: {
            return {
                ...state,
                newCourseSelectValue: payload.data,
                isFetchingEditInformation: false
            };
        }
        case INITIALISE_COURSE_SELECT_OPTIONS: {
            const {
                countryOption,
                yearOption,
                allYearsOption,
                courseOption,
                newCourseOption,
                noNewCourseFoundOption,
                noUPFCourseFoundOption: noUPFCourseFoundOptionText,
                upfCourseAdminSelectionOption: upfCourseAdminSelectionOptionText,
                upfCurrentCourseSuffix
            } = payload.data;

            // A list of default course select options
            const defaultCountryOption = {
                id: '',
                code: '',
                name: countryOption
            };
            const defaultYearOption = {
                yearGroupId: '',
                yearGroupEnum: '',
                longName: yearOption
            };
            const defaultAllYearsOption = {
                yearGroupId: '',
                yearGroupEnum: '-1',
                longName: allYearsOption
            };
            const defaultCourseOption = {
                id: '',
                name: courseOption
            };
            const defaultNewCourseOption = {
                id: DEFAULT_NEW_COURSE_ID,
                name: newCourseOption
            };
            const defaultNoNewCourseFoundOption = {
                id: DEFAULT_NEW_COURSE_ID,
                name: noNewCourseFoundOption
            };
            const upfCourseAdminSelectionOption = {
                id: '-1',
                name: upfCourseAdminSelectionOptionText
            };
            const noUPFCourseFoundOption = {
                id: NO_UPF_COURSE_FOUND_ID,
                name: noUPFCourseFoundOptionText
            };
            return {
                ...state,
                defaultCountryOption,
                defaultYearOption,
                defaultAllYearsOption,
                defaultCourseOption,
                defaultNewCourseOption,
                defaultNoNewCourseFoundOption,
                upfCourseAdminSelectionOption,
                noUPFCourseFoundOption,
                defaultSelectOptions: payload.data,
                upfCurrentCourseSuffix
            };
        }
        case GET_NEW_COURSE_AVAILABILITY_CRITERIA: {
            const { newCoursesAvailabilityCriteria } = payload;
            return {
                ...state,
                newCoursesAvailabilityCriteria
            };
        }
        case RESET_EDIT_INFORMATION: {
            return {
                ...state,
                isFetchingEditInformation: false
            };
        }
        // ------- Course Actions ------- End
        // ------- Group Actions ------- Start
        case UPDATE_GROUP_SELECTION: {
            const { value, isSelected } = payload;
            const classGroups = updateGroupVisibleProperties(state.classGroups, value, isSelected);

            // Filter the students
            const classGroupStudents = state.classGroupStudents.map((student) => {
                const isStudentVisible = isGroupVisible(student.groupId, classGroups);
                return {
                    ...student,
                    isVisible: isStudentVisible
                };
            });
            const visibleStudents = classGroupStudents.filter(student => student.isVisible);

            // Filter the selectedStudents (if necessary)
            const initialSelectedStudentIds = state.mainSelectedStudentIds;
            // Find if the userProfileId is within the first selected students
            const validStudentIds = visibleStudents.filter(student => (
                initialSelectedStudentIds.includes(student.userProfileId)
            ));
            const mainSelectedStudentIds = setUpAllCurrentStudents(validStudentIds);
            const mainAllCurrentStudentIds = setUpAllCurrentStudents(visibleStudents);
            // As long as there's data, if there isn't... then set the check all to be off
            const mainCheckAllIsSelected = mainSelectedStudentIds.length > 0 ?
                isEqual(mainSelectedStudentIds, mainAllCurrentStudentIds) : false;

            const mainListBodyProperties = {
                mainCheckAllIsSelected,
                mainSelectedStudentIds,
                mainAllCurrentStudentIds
            };

            return {
                ...state,
                classGroupStudents,
                classGroups,
                ...mainListBodyProperties
            };
        }
        case EDIT_GROUP_INFORMATION_START: {
            return {
                ...state,
                isFetchingEditInformation: true
            };
        }
        case EDIT_GROUP_INFORMATION_END: {
            const {
                countrySelectValue,
                courseSelectValue,
                groupCourseOption = null,
                newCourseSelectValue,
                groupNewCourseOption = null,
                groupUpfCourseOption = null,
                upfCourseSelectValue,
                yearSelectValue,
                countryCode
            } = payload.data;

            return {
                ...state,
                countrySelectValue,
                courseSelectValue,
                groupCourseOption,
                groupUpfCourseOption,
                upfCourseSelectValue,
                newCourseSelectValue,
                groupNewCourseOption,
                yearSelectValue,
                countryCode
            };
        }

        case CREATE_MULTI_YEAR_GROUPS: {
            return {
                ...state,
                hasContentLoaded: false,
                createdMultiLevelGroupsCount: 0
            };
        }

        case RESET_MULTI_YEAR_GROUPS_FETCH: {
            return {
                ...state,
                isMultiLevelGroupsCreated: false
            };
        }

        case UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT: {
            const {
                count
            } = payload.data;

            return {
                ...state,
                createdMultiLevelGroupsCount: count || 0,
                isMultiLevelGroupsCreated: true
            };
        }
        // ------- Group Actions  ------- End
        // ------- Student Actions ------- Start
        case SELECT_CHECKBOX_STUDENT: {
            const userProfileId = payload.data;
            // Variables
            let tempSelectedStudentIds = [...state.mainSelectedStudentIds];
            const index = tempSelectedStudentIds.indexOf(userProfileId);

            // If there's already an item of the studentId in the currently selected student ids, then remove it
            if (index > -1) {
                tempSelectedStudentIds.splice(index, 1);
            } else { // Otherwise append the id to the list of selected students
                tempSelectedStudentIds = [...state.mainSelectedStudentIds, userProfileId];
            }

            const mainAllCurrentStudentIds = state.mainAllCurrentStudentIds;
            const mainCheckAllIsSelected = isEqual(tempSelectedStudentIds, mainAllCurrentStudentIds);

            return {
                ...state,
                mainCheckAllIsSelected,
                mainSelectedStudentIds: tempSelectedStudentIds
            };
        }
        case SELECT_ALL_CHECKBOX_STUDENT: {
            const mainSelectedStudentIds = isEqual(state.mainAllCurrentStudentIds, state.mainSelectedStudentIds) ?
                [] : state.mainAllCurrentStudentIds;
            return {
                ...state,
                mainCheckAllIsSelected: !state.mainCheckAllIsSelected,
                mainSelectedStudentIds
            };
        }
        case CHANGE_PASSWORD: {
            const tempStudents = [...state.classGroupStudents];
            const userProfileId = payload.userProfileId;
            const password = payload.newPassword;

            const students = tempStudents.map((student) => {
                if (student.userProfileId === userProfileId) {
                    return {
                        ...student,
                        password
                    };
                }
                return student;
            });

            return {
                ...state,
                classGroupStudents: students
            };
        }
        // ------- Student Actions ------- End

        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./containers/console/console-reducer.js